import { createSessionFailureHandler } from "@bayesprep/shared-ui/session";
export { SESSION_ENDED } from "@bayesprep/shared-ui/session";
export const {
  readSessionNotice,
  takeSessionNotice,
  endSession,
  confirmSessionFailure,
} = createSessionFailureHandler();
